import { Injectable } from '@angular/core';

//Import users

//Import Obsevable to make service asynchronous
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { of } from 'rxjs/observable/of';

//Import for messages
import { MessageService } from 'services/message.service'
import { Http, Headers, RequestOptions } from '@angular/http';

import { AuthService } from 'services/auth.service';

import * as _ from 'underscore';
import { PagerService } from 'services/index';

import { Pager } from '../../../pager';
import { GlobalService } from 'services/global.service';

@Injectable()
export class PreviewService {
  domain = this.authService.domain;
  previewsAll : any[];
  processing = false;
  
  previews = new Subject<any[]>();
  questions = new Subject<any[]>();
  user : any[];
  pagerProcess;
  pager = new Subject<Pager>();
  sortingConsultant = 'createdAt';
  Acs = false;
  totalItems = this.globalService.totalItems;

  roles : any[];
  accounts : any[];
  
  previews$ = this.previews.asObservable();
  questions$ = this.questions.asObservable();
  pager$ = this.pager.asObservable();

  constructor(
  	private messageService: MessageService,
  	private http: Http,
    private authService: AuthService,
    private pagerService:　PagerService,
    private globalService:GlobalService,
  ) {

  }


  //---------------------------------- Getting API data with subscribe ---------------------------------------------------
  //  getting preview by course_format in course_format_delivery table
  // Type : GET
  // Parse : 
  gettingPreviewCourse(courseFormatId) {
    const url = this.domain + "course_format_delivery/getPreview/" + courseFormatId;

    return this.http.get(url, this.authService.options).map(res => res.json());    
  }


  // gettingPreviewQuestionAPI(questionId){
  //   return this.http.get( this.domain + 'user/' + questionId , this.authService.options).map(res => res.json());       
  // }

  //  getting question data for answer by question id 
  // Type : GET
  // Parse : question id
  apiAnswer(questionId) {
    const url = this.domain + "question/" + questionId;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }
  //preview
  apiAnswerPreview(questionId,courseFormatId) {
    const url = this.domain + "question/preview/" + questionId+'/'+courseFormatId;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  //  getting feedback for next question 
  // Type : GET
  // Parse : question id , answer
  apiFeeback(questionId, answer) {
    const url = this.domain + "course_format_delivery/getFeedback/" + questionId + "/" + answer;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  // ---------------------------------- Process subcribe API data --------------------------------------------------------
  　/** @function gettingPreviewProcess */
   // the above is the same as:
   /** @function
    * @name gettingPreviewProcess
    * 
    * @param {string} courseFormatId id of the course_format
    * @todo getting question by delivery date by course format id
    *  */
  gettingPreviewProcess(courseFormatId){
    this.gettingPreviewCourse(courseFormatId).subscribe( data => {
      this.previews.next(data);
    },err => {
      console.log(err);
    });
  }

   /** @function getAnswer */
   // the above is the same as:
   /** @function
    * @name getAnswer
    * 
    * @param {string} courseFormatId id of the course_format
    * @todo getting question by delivery date by course format id
    *  */
  getAnswer(questionId,courseFormatId) {
    return new Promise<any>((resolve, reject) => {
      this.apiAnswerPreview(questionId,courseFormatId).subscribe( res => {
        resolve(res);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

   /** @function getFeedback */
   // the above is the same as:
   /** @function
    * @name getFeedback
    * 
    * @param {string} questionId id of the answered question
    * @param {string} answer answer of the answered question
    * @todo getting feedback next question
    *  */
  getFeedback(questionId, answer) {
    return new Promise<any>((resolve, reject) => {
      this.apiFeeback(questionId, answer).subscribe(response => {
        resolve(response);
      }, err => {
        console.log(err);
        reject(err);
      });
    });
  }

  gettingPreviewQuestionProcess(questionId){
       //   this.gettingPreviewQuestionAPI(questionId).subscribe( data => {
    //     this.previews.next(data);
    //   },err => {
    //     console.log(err);
    //   });
    var data = ["adsas","dasd"];
    this.questions.next(data);
  }
}


// WEBPACK FOOTER //
// ./src/app/component/aplication/preview/preview.service.ts